import { Status } from 'src/api/constants';
import { IResponsePriceScheme } from 'src/types/price.types';
import { fetch } from 'src/api/fetchWrapper/fetch';

export interface ICreatePriceSchemeRequestBody {
  name: string;
}

// Reduces duplication between createPriceScheme call and duplicatePriceScheme call
export const postPriceSchemeRequest = async (url: string, body: string): Promise<IResponsePriceScheme> => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body,
    });

    const json = await response.json();
    if (response.status === Status.SUCCESS || response.status === Status.ACCEPTED) {
      return json.data[0];
    }
    const hasErrorMsg = typeof json === 'object' && 'message' in json;
    throw new Error(hasErrorMsg ? json.message : 'Failed to create price scheme');
  } catch (error) {
    const throwable = error instanceof Error ? error : new Error('Unknown failure');
    throw throwable;
  }
};
